import { Col } from '@components/Layout/Col';
import { Row } from '@components/Layout/Row';
import { HTTPCodes } from '@lib/http';
import { Page } from '@packages/layout';
import { IF } from '@packages/react/lib/if';
import { font } from '@packages/style/fonts';
import React from 'react';
import styled from 'styled-components';

interface ErrorCardProps {
    code?: number;
    message?: string;
}

const MESSAGES = {
    [HTTPCodes.HTTP_NOT_FOUND]: 'Page not found!',
    [HTTPCodes.HTTP_FORBIDDEN]: 'Forbidden page access!',
    [HTTPCodes.HTTP_UNAUTHORIZED]: 'You are not authorized!',
};

/**
 * @author:   Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class:    ErrorPage
 * @date:     18.09.2018
 * @time:     14:29
 * @refactor: 02.06.2019 00:12
 */
export const ErrorPage = React.memo<ErrorCardProps>(({ code, message }: any) => (
    <Page title={MESSAGES[code]}>
        <Style align={'center'} justify={'center'}>
            <ErrorCard code={code} message={message} />
        </Style>
    </Page>
));

export const ErrorCard = React.memo<ErrorCardProps>(({ code, message, ...rest }: any) => (
    <Col align={'center'} layout={'column'} justify={'center'} xs padding={14} {...rest}>
        <Card>
            {IF(code, <p className={'code'}>{code}</p>)}
            {IF(message || code, <h2 className={'message'}>{message || MESSAGES[code]}</h2>)}
        </Card>
    </Col>
));

export default ErrorPage;

const Card = styled.div`
    & {
        display: inline-flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        padding: 14px 30px;
        background-color: transparent;
        border-radius: 5px;
        .code {
            margin: 0;
            ${font(32, 500)}
        }

        .code,
        .message {
            text-transform: uppercase;
            color: #565656;
        }

        .message {
            ${font(14, 500)}
        }

        .code + .message {
            padding-left: 20px;
            margin: 0 0 0 20px;
            border-left: 1px solid #888;
        }
    }
`;

const Style = styled(Row)`
    & {
        min-height: 100%;
    }
`;
